import { setupStaleAssetRecovery } from "@mixitone/util";
import { oom } from "@mixitone/oom";
import SupabaseDatabaseAdapter from "@mixitone/oom/adapters/SupabaseDatabaseAdapter";
import { initTelemetry, TelemetryProvider } from "@mixitone/telemetry";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { App } from "./App";
import { Authenticated, MightBeAuthenticated } from "./Components/Authenticated";
import { ActivationPage } from "./Pages/ActivationPage";
import { ClubDetailsPage } from "./Pages/Clubs/ClubDetailsPage";
import { LandingPage } from "./Pages/LandingPage";
import { MagicLinkPage } from "./Pages/MagicLinkPage";
import { MemberInviteLandingPage } from "./Pages/MemberInviteLandingPage";
import { ProfilePage } from "./Pages/ProfilePage";
import { TagLandingPage } from "./Pages/TagLandingPage";
import { CompetitionDetailPage } from "./Pages/Tournament/CompetitionDetailPage";
import { CompetitionRegistrationPage } from "./Pages/Tournament/CompetitionRegistrationPage";
import { PlayerCompetitionsPage } from "./Pages/Tournament/PlayerCompetitionsPage";
import { TournamentPage } from "./Pages/Tournament/TournamentPage";
import "./index.css";
import { createSupabase } from "./supabaseClient";
import { ClubInvitePage } from "./Pages/Clubs/ClubInvitePage";
import { ClubPage } from "./Pages/Clubs/ClubPage";
import { ClubDocumentsPage } from "./Pages/Clubs/ClubDocumentsPage";
import { RouteErrorPage } from "./Pages/RouteErrorPage";

setupStaleAssetRecovery();

const supabase = createSupabase();
oom.configure({
  adapter: new SupabaseDatabaseAdapter(supabase),
  realtimeMode: "postgres_changes",
});

if (import.meta.env.VITE_TEST !== "1") {
  initTelemetry();
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "/",
        element: <ActivationPage />,
      },
      {
        path: "/magic/:token",
        element: <MagicLinkPage />,
      },
      {
        path: "/invite/:token",
        element: <MemberInviteLandingPage />,
      },
      {
        path: "tag/:tag",
        element: <TagLandingPage />,
      },
      {
        path: "tournament",
        element: <MightBeAuthenticated />,
        children: [
          {
            path: ":portalSlug",
            element: <TournamentPage />,
          },
          {
            path: ":portalSlug/register/:competitionId",
            element: <CompetitionRegistrationPage />,
          },
        ],
      },
      {
        path: "in",
        element: <Authenticated />,
        children: [
          {
            path: "home",
            element: <LandingPage />,
          },
          {
            path: "profile",
            element: <ProfilePage />,
          },
          {
            path: "club/:clubId",
            element: <ClubPage />,
            children: [
              {
                path: "",
                element: <ClubDetailsPage />,
              },
              {
                path: "invite",
                element: <ClubInvitePage />,
              },
              {
                path: "documents",
                element: <ClubDocumentsPage />,
              },
            ],
          },
          {
            path: "tournaments",
            element: <PlayerCompetitionsPage />,
          },
          {
            path: "tournaments/:portalSlug/manage/:competitionId",
            element: <CompetitionDetailPage />,
          },
        ],
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <TelemetryProvider>
    <RouterProvider router={router} />
  </TelemetryProvider>,
);
